import React, { ReactNode } from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Box, BoxProps } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
type BenefitCardProps = {
  title: string;
  labels: Record<string, string>[];
  body: ReactNode;
} & BoxProps;
export const BenefitCard = ({
  title,
  labels,
  body,
  ...rest
}: BenefitCardProps) => <Box borderColor="backgroundGray" borderRadius="12px" borderStyle="solid" borderWidth="2px" p={3} {...rest} data-sentry-element="Box" data-sentry-component="BenefitCard" data-sentry-source-file="index.tsx">
    <Flex alignItems={['flex-start', null, 'center', null]} flexDirection={['column', null, 'row', null]} justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Box order={[2, null, 1, null]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography fontSize="20px" m={0} variant="h3" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {title}
        </Typography>
      </Box>

      <Flex alignItems="center" justifyContent="space-between" order={[1, null, 2, null]} mb={[2, null, 0, null]} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {labels.map(({
        bg,
        text
      }) => <Box key={text} bg={bg} borderRadius="3px" p="4px" mr={[2, null, 0, null]} ml={[0, null, 2, null]}>
            <Typography color="white" fontFamily="muliBold" fontSize="13px" textTransform="uppercase" m={0}>
              {text}
            </Typography>
          </Box>)}
      </Flex>
    </Flex>
    {body}
  </Box>;